import { render, staticRenderFns } from "./TakeQuizzWidget.vue?vue&type=template&id=449fa1a8&scoped=true"
import script from "./TakeQuizzWidget.vue?vue&type=script&lang=js"
export * from "./TakeQuizzWidget.vue?vue&type=script&lang=js"
import style0 from "./TakeQuizzWidget.vue?vue&type=style&index=0&id=449fa1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449fa1a8",
  null
  
)

export default component.exports